import { SyncOutlined } from "@ant-design/icons";
import { Alert, Button, Space, Spin } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { appStore, OverlayPage } from "src/appStore";
import { cvtError, getErrorMessage } from "src/common/onError";

import * as styles from "./AuthChecker.module.less";
import { LoginPage } from "./overlays/LoginPage";

interface PropsAuthChecker {
  children?: React.ReactNode;
}

const overlaysMap: Record<OverlayPage, React.ReactElement> = {
  login: <LoginPage />,
};

export const AuthChecker: React.FC<PropsAuthChecker> = observer(
  ({ children }: PropsAuthChecker) => {
    const { overlayType } = appStore;
    if (overlayType) {
      return (
        overlaysMap[overlayType] ?? (
          <div>
            Unknown overlay <b>{appStore.overlayType}</b>
          </div>
        )
      );
    }
    const { status } = appStore.userData;
    if (status === "error") {
      const params = getErrorMessage(cvtError(appStore.userData.error));
      return (
        <div className={styles.vertBlock}>
          <h1>{t("Error when accessing the server")}</h1>
          <Alert type="error" showIcon {...params} />
          <Space>
            <Button
              type="primary"
              onClick={() => appStore.init()}
              icon={<SyncOutlined />}
            >
              {t("Repeat")}
            </Button>
          </Space>
        </div>
      );
    }
    if (status === "ready") {
      return children;
    }
    if (status === "wait") {
      return (
        <div className={styles.wait}>
          <Spin />
          <span>Загрузка информации пользователя...</span>
        </div>
      );
    }
    return <div>Invalid status: {status}</div>;
  },
);
